import { LinearProgress, Stack } from '@mui/material';
import _ from 'lodash';
import { useEffect } from 'react';
import { useDeepCompareCallback } from '../../../hooks/useDeepCompare';
import { useFacilityMarkers } from '../../../hooks/useFacilityMarkers';
import FacilityInfoCard from './FacilityDetailCard';
import {
  AddNewFacillityButton,
  SearchNearbyButton,
  ZoomButton,
} from './FloatingButtons';
import { useAuthAxios } from '../../../hooks/useAuthAxios';

export function NaverMapPanel({
  map,
  setRef,
  selectedId,
  setSelectedId,
  search,
  inspectionStatus,
  department,
  categoryType,
  bound,
  onListRefresh,
  ...props
}) {
  const params = {
    searchText: search,
    inspectionStatus,
    maintenanceDepartmentId: department,
    categoryId: categoryType,
    minLatitude: bound?.minLat,
    maxLatitude: bound?.maxLat,
    minLongitude: bound?.minLng,
    maxLongitude: bound?.maxLng,
  };

  const [getMarkersResult, getMarkers] = useAuthAxios(
    {
      method: 'GET',
      url: `/api/v1/facility`,
      params: params,
    },
    { manual: false },
  );
  const { loading } = getMarkersResult;

  const markers = _.get(getMarkersResult, 'response.data.result');

  const refreshMarkers = useDeepCompareCallback(async () => {
    if (map) {
      const bounds = map ? _.result(map, 'getBounds') : undefined;
      getMarkers({ params: { ...params, bounds } });
    }
  }, [params, map]);

  useEffect(() => {
    refreshMarkers();
  }, [refreshMarkers]);

  useFacilityMarkers(map, markers, facility => {
    setSelectedId(facility.facilityId);
  });

  const handleZoomChange = () => {
    const max_lat = _.result(map, 'getBounds._max._lat');
    const min_lat = _.result(map, 'getBounds._min._lat');
    const max_lng = _.result(map, 'getBounds._max._lng');
    const min_lng = _.result(map, 'getBounds._min._lng');

    const newParams = {
      ...params,
      minLatitude: min_lat,
      maxLatitude: max_lat,
      minLongitude: min_lng,
      maxLongitude: max_lng,
    };

    getMarkers({ params: newParams });
    setSelectedId('');
  };

  return (
    <Stack ref={setRef} {...props} position="relative">
      {selectedId && (
        <FacilityInfoCard
          facilityId={selectedId}
          onClose={() => setSelectedId('')}
          getFacilities={getMarkers}
        />
      )}
      {map && (
        <>
          <AddNewFacillityButton map={map} />
          <ZoomButton map={map} onZoomChange={handleZoomChange} />
          <SearchNearbyButton onClick={onListRefresh} />
        </>
      )}
      {loading && (
        <LinearProgress
          style={{ position: 'absolute', bottom: 0, width: '100%' }}
        />
      )}
    </Stack>
  );
}
